import styled from "styled-components";
import { CircleButton } from "./CircleButton";
import { EditableInput } from "./EditableInput";

const Modifier = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  padding: 0 0.25rem;
  padding-top: 1.25rem;
  margin: 0.15rem 0;
  color: ${({ amount }) => (amount > 0 ? "#009045" : "#B22222")};
  text-shadow: 0 0 0.5rem #000a;
`;

const ButtonContainer = styled.span``;

export const ExpenseModifier = ({
  handleRemoveExpense,
  handleUpdateExpense,
  amount,
}) => (
  <Modifier>
    <EditableInput
      amount={amount}
      notify={(value) => handleUpdateExpense(value)}
    />
    <ButtonContainer>
      <CircleButton handleClick={() => handleRemoveExpense()} positive>
        -
      </CircleButton>
    </ButtonContainer>
  </Modifier>
);
